import { useState } from 'react';
export default function useAccordion() {
  const [expanded, setExpanded] = useState('panel0');
  const handleAccordionChange = panel => {
    setExpanded(expanded !== panel ? panel : false);
  };
  return {
    expanded,
    handleAccordionChange
  };
}